<template>
    <validation-observer ref="observer" tag="div" class="observer"
                         v-slot="{passes, invalid}">

        <div class="grid grid-cols-6 gap-6 mt-8">
            <div class="col-span-6">
                <validation-provider ref="email" name="email" rules="required|email" v-slot="{ errors, valid, touched }">
                    <label for="email" class="block text-sm font-medium text-gray-700">
                        What is your email address?
                    </label>

                    <input v-model="trimmedEmail" type="text" name="email" id="email" autocomplete="email" @focus="$emit('focus')"
                        class="mt-1 block w-full md:w-1/2 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        :class="{
                            'border-2 border-red-300 placeholder-red-300':errors.length,
                            'border border-gray-300 ': !errors.length
                        }"
                    />
                    <p v-if="false && showSubWording" class="mt-2 text-sm text-gray-500">We'll send you a copy of your quote</p>
                  <p class="mt-2 text-sm text-red-600" v-if="errors.length && (touched || submitted)">
                    {{ errors[0].charAt(0).toUpperCase() + errors[0].slice(1) }}{{ (showSubWording && errors[0] === 'This field is required' ? ' - we will email you a copy of your quote' : '') }}</p>
                </validation-provider>
            </div>
        </div>

    </validation-observer>

</template>

<script>
export default {
    name: "EmailInput",
    data() {
    return {
      submitted: false,
    }
  },
    props: {
        form: {
            type: Object,
            default: () => {},
        },
        showSubWording: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        trimmedEmail: {
            get() {
                return this.form.emailAddress;
            },
            set(value) {
                this.form.emailAddress = value.trim();
            }
        },
    },
    methods: {
        async validates(){            
          this.submitted = true;
          return await this.$refs.observer.validate()
        },
    },
}
</script>

<style scoped>

</style>
